import { render, staticRenderFns } from "./feedbackLists.vue?vue&type=template&id=5485ea66&scoped=true"
import script from "./feedbackLists.vue?vue&type=script&lang=js"
export * from "./feedbackLists.vue?vue&type=script&lang=js"
import style0 from "./feedbackLists.vue?vue&type=style&index=0&id=5485ea66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5485ea66",
  null
  
)

export default component.exports